function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'ramda/src/isEmpty';
import pick from 'ramda/src/pick';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { PostalCodeSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../../customer/addresses/addresses.constants';
import { IsAddressMandatoryInCreditCheckSelector } from '../../../reducers/selectors/credit.check.selectors';
var CreditCheckAddressSectionController = /*#__PURE__*/function () {
  function CreditCheckAddressSectionController($ngRedux) {
    _classCallCheck(this, CreditCheckAddressSectionController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CoreLocaleKeys: CoreLocaleKeys,
      creditCheckAddressModal: {},
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      formMaxLengthValidation: ADDRESS_FORM_FIELD_MAX_LENGTH,
      isCountryDisabled: this.isCountryDisabled || false,
      onAddressFormUpdate: this.onAddressFormUpdate.bind(this),
      pickAddressFormDataFrom: this.pickAddressFormDataFrom.bind(this),
      toggleCreditCheckAddressSection: this.toggleCreditCheckAddressSection.bind(this)
    });
  }
  return _createClass(CreditCheckAddressSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressCountries: MetadataOptionsForCodeValuesSelector(CODES.AddressCountry, store),
          addressCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
          isAddressMandatoryInCreditCheck: IsAddressMandatoryInCreditCheckSelector(store),
          postalCode: PostalCodeSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.addressCountriesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressCountry);
      }
      Object.assign(this.creditCheckAddressModal, this.customerModel.AddressForCreditCheck ? this.pickAddressFormDataFrom(this.customerModel.AddressForCreditCheck) : null);
      this.handleFormChanged();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (!isEmpty(this.creditCheckAddressModal) && changesObj.customerModel && changesObj.customerModel.currentValue) {
        Object.assign(this.creditCheckAddressModal, this.pickAddressFormDataFrom(changesObj.customerModel.currentValue.AddressForCreditCheck));
      }
    }
  }, {
    key: "onAddressFormUpdate",
    value: function onAddressFormUpdate(creditCheckAddressModal) {
      if (this.customerModel.AddressForCreditCheck) {
        Object.assign(this.customerModel.AddressForCreditCheck, creditCheckAddressModal);
      }
      Object.assign(this.creditCheckAddressModal, creditCheckAddressModal);
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "pickAddressFormDataFrom",
    value: function pickAddressFormDataFrom(model) {
      return pick(['addressLine1', 'addressLine2', 'city', 'country', 'stateRegionProvince', 'postalCode'], model);
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "isError",
    value: function isError(formElement) {
      return (formElement.$error.pattern || formElement.$error.required || formElement.$error.maxlength) && (formElement.$touched || this.isFormSubmitted);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.state.isAddressMandatoryInCreditCheck && this.markMandatoryCreditCheckFieldsDisabled;
    }
  }, {
    key: "toggleCreditCheckAddressSection",
    value: function toggleCreditCheckAddressSection() {
      this.customerModel.showCreditCheckAddressSection = this.showCreditCheckAddressSection;
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./credit.check.address.section.html'),
  bindings: {
    addressStateOptions: '<',
    customerModel: '<',
    isCountryDisabled: '<',
    errorLookup: '<',
    onFormChanged: '&',
    isFormSubmitted: '<',
    markMandatoryCreditCheckFieldsDisabled: '<?'
  },
  controller: CreditCheckAddressSectionController,
  controllerAs: 'CreditCheckAddressSection'
};